import { BaseProps } from '@/components/types'
import { ReactElement } from 'react'
import DefaultTableLayout from '../DefaultTableLayout'
import '@/assets/scss/app/card-table-layout.scss'

function TableLayoutGrid ( props: TableLayoutGridProps ) {
    const { grid, ...rest } = props

    return (
        <DefaultTableLayout { ...rest }>
            { grid && grid }
        </DefaultTableLayout>
    )
}

export default TableLayoutGrid

export interface TableLayoutGridProps extends BaseProps {
    title?: string
    height?: string | number
    actions?: ReactElement
    grid?: ReactElement
}